/**
 * The floating toolbar surface: controls that float over a work surface (the
 * builder's bottom toolbar and its canvas corner pills). An elevated fill with
 * a 0.5px border-secondary hairline shadow under the large shadow; the edge
 * comes from the shadows, so no stroke. See `## Elevation` in design.md.
 */
export const floatingToolbarSurfaceClassName =
  "bg-bg-elevated shadow-[0_0_0_0.5px_var(--color-border-secondary),var(--shadow-large)]";
